import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
 
const AuthCallBack = () => {
  const navigate = useNavigate();
 
  useEffect(() => {
    const handleCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code");
 
      if (code) {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/api/auth/salespersonAuth/auth/callback?code=${code}`
          );
          const result = await response.json();
 
          if (result.isValidUser) {
            // Store login state in localStorage
            localStorage.setItem("validWithOTP", true);
            localStorage.setItem("validSalesPerson", true);
            localStorage.setItem("validNewCustomer", true);
            localStorage.setItem("scannedQR", false);
           
            // Notify user and navigate to home screen
            toast.success("Login successful. Redirecting...");
            setTimeout(() => {
              navigate("/home/inventory");
              window.location.reload();
            }, 3000);
          } else {
            toast.error("Login failed.");
          }
        } catch (error) {
          toast.error("An error occurred. Please try again.");
          console.error("Error in callback:", error);
        }
      }
    };
 
    handleCallback();
  }, [navigate]);
 
  return <div>Processing login...</div>;
};
 
export default AuthCallBack;
 